var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Content"},[_c('div',{staticClass:"bar",attrs:{"id":_vm.echartsId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }